import React from 'react';
import PropTypes from 'prop-types';

function SearchBarItem(props) {
    const {
        className, label, onClick, content, children, hasInput, removeGlobalClassName,
    } = props;

    return (
        <div
            className={`${!removeGlobalClassName ? 'kbe-search-bar-item' : ''} ${className} ${hasInput ? 'has-input' : ''}`}
            onClick={onClick}
            aria-hidden="true"
        >
            <div className="kbe-search-bar-item-label">
                { label }
            </div>
            <div className="kbe-search-bar-content search-bar-input-custom-class bf-search-bar-content">
                { content || children }
            </div>
        </div>
    );
}

SearchBarItem.defaultProps = {
    className             : '',
    content               : '',
    children              : '',
    hasInput              : false,
    onClick               : () => {},
    removeGlobalClassName : false,
};

SearchBarItem.propTypes = {
    className             : PropTypes.string,
    label                 : PropTypes.oneOfType([ PropTypes.node, PropTypes.string ]).isRequired,
    onClick               : PropTypes.func,
    content               : PropTypes.oneOfType([ PropTypes.node, PropTypes.string ]),
    children              : PropTypes.oneOfType([ PropTypes.node, PropTypes.string ]),
    hasInput              : PropTypes.bool,
    removeGlobalClassName : PropTypes.bool,
};

export default SearchBarItem;
